module.exports = __webpack_public_path__ + "8d01b878b3e7907cd6c3e70563d52814.jpg";